'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const form_1 = require('../contexts/form');
function useChangeHandler(transform) {
  const { setField } = (0, form_1.useForm)();
  return event => {
    if (!event.target) return;
    const target = event.target;
    const { value } = target;
    let currentValue = value;
    // if a checkbox, use a boolean of the checked
    if (target.type === 'checkbox') currentValue = target.checked;
    if (currentValue === 'false') currentValue = false;
    if (currentValue === 'true') currentValue = true;
    currentValue = transform(currentValue);
    setField(target.name, currentValue);
  };
}
exports.default = useChangeHandler;
//# sourceMappingURL=useChangeHandler.js.map
